<template>
    <v-dialog persistent v-model="dialogOpen" max-width="900">
        <v-card class="pa-3" v-if="student">
            <div v-if="!student.name" class="pa-3">
                <v-card-title class="pl-0">New Student</v-card-title>
                <v-flex xs5>
                    <v-select
                        hide-details
                        :items="newStudents"
                        label="New Student"
                        ref="newStudent"
                        v-model="newStudent"
                        :rules="[]"
                        box
                        item-text="`${data.item.engName} - ${data.item.hebName} (${data.item.class})` "
                        clearable
                    >
                        <template slot="selection" slot-scope="data">
                            {{ data.item.engName }} -
                            {{ data.item.hebName }}
                        </template>
                        <template slot="item" slot-scope="data">
                            <v-list-tile-content>
                                <v-list-tile-title
                                    v-html="
                                        `${data.item.engName} - ${
                                            data.item.hebName
                                        }`
                                    "
                                >
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </template>
                    </v-select>
                </v-flex>
            </div>
            <div v-if="student.name">
                <v-layout row justify-space-between>
                    <v-card-title
                        >{{ student.name }}
                        -
                        {{ student.hebName }}
                        ({{ student.class }})</v-card-title
                    >
                    <v-card-actions>
                        <v-btn
                            class="text-xs-right"
                            small
                            color="success"
                            @click="resetPrice"
                            >Reset Price</v-btn
                        >
                    </v-card-actions>
                </v-layout>
                <v-divider></v-divider>
                <v-layout row class="pa-3">
                    <v-radio-group
                        v-model="student.enrollment.regType"
                        row
                        hide-details
                    >
                        <v-radio
                            class="py-2"
                            label="Full"
                            value="FULL"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class="pa-2"
                            label="First Half"
                            value="HALF 1"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class="pa-2"
                            label="Second Half"
                            value="HALF 2"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class="pa-2"
                            label="Custom"
                            value="CUSTOM"
                            color="success"
                        ></v-radio>
                        <v-radio
                            class="pa-2"
                            label="None"
                            value="NONE"
                            color="success"
                        ></v-radio>
                    </v-radio-group>
                </v-layout>
                <v-layout
                    class="pa-3 mt-2"
                    row
                    justify-start
                    v-if="student.enrollment.regType == 'CUSTOM'"
                >
                    <v-checkbox
                        class="ma-0 pa-0 weeks-selection"
                        v-for="(week, index) in dates.map((d) => d.parshe)"
                        :key="week"
                        :label="`${index + 1} ${week}`"
                        color="success"
                        v-model="student.enrollment[getWeekProperty(index)]"
                    ></v-checkbox>
                </v-layout>
                <v-layout row class="pa-3 mt-2">
                    <v-flex xs4>
                        <v-select
                            hide-details
                            :items="getClassList(student)"
                            label="Class"
                            ref="chosenClass"
                            v-model="student.chosenClass"
                            :rules="[
                                (value) =>
                                    rules.required(
                                        value,
                                        student.enrollment.regType,
                                    ),
                            ]"
                            box
                            item-text="`${data.item.grade} - ${data.item.teacher}`"
                            clearable
                        >
                            <template slot="selection" slot-scope="data">
                                {{ data.item.grade }} -
                                {{ data.item.teacher }}
                            </template>
                            <template slot="item" slot-scope="data">
                                <v-list-tile-content>
                                    <v-list-tile-title
                                        v-html="
                                            `${data.item.grade} - ${
                                                data.item.teacher
                                            }`
                                        "
                                    >
                                    </v-list-tile-title>
                                </v-list-tile-content>
                            </template>
                        </v-select>
                    </v-flex>

                    <v-spacer> </v-spacer>
                    <v-layout row justify-end>
                        <div v-if="!editingAmount">
                            <v-layout row>
                                <v-card-title
                                    class="py-0"
                                    style="background-color: #FFF; border-style: solid; border-color: #5cb860;"
                                >
                                    <div class="font-weight-medium">
                                        ${{ getPaymentAmount(student) }}
                                    </div>
                                </v-card-title>
                                <v-card-actions class="py-0">
                                    <v-btn
                                        @click="edit"
                                        flat
                                        icon
                                        class="text-xs-right"
                                        color="success"
                                    >
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-layout>
                        </div>
                        <div v-else>
                            <v-layout row>
                                <v-text-field
                                    class="mr-3"
                                    label="Amount"
                                    placeholder="Amount"
                                    v-model="paymentAmount"
                                    prefix="$"
                                    type="number"
                                    hide-details
                                ></v-text-field>
                                <v-btn
                                    flat
                                    class="mr-1"
                                    @click="() => rollbackEditingAmount()"
                                    small
                                >
                                    Cancel
                                </v-btn>
                                <v-btn
                                    flat
                                    @click="editingAmount = false"
                                    small
                                    color="success"
                                >
                                    save
                                </v-btn>
                            </v-layout>
                        </div>
                    </v-layout>
                </v-layout>

                <v-flex xs8>
                    <v-layout row justify-start class="mt-2">
                        <v-checkbox
                            v-model="student.enrollment.lunchDoc"
                            class="ml-4"
                            label="Lunch Document"
                            color="success"
                        >
                        </v-checkbox>
                        <v-checkbox
                            v-model="student.enrollment.tripMoney"
                            class="ml-2"
                            label="Trip Money"
                            color="success"
                        >
                        </v-checkbox>
                        <v-text-field
                            style="width: 71px;"
                            v-if="student.enrollment.tripMoney"
                            class="mx-2"
                            label="Trip Amount"
                            placeholder="Trip Amount"
                            v-model="student.enrollment.tripAmount"
                            prefix="$"
                            type="number"
                            hide-details
                        ></v-text-field>
                    </v-layout>
                </v-flex>
            </div>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="cancel" dark color="default">
                    Close
                </v-btn>
                <v-btn v-if="student.name" color="success" @click="save">
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import { groupBy, onlyUnique, getDomain } from "../../utils/helpers.js";

export default {
    props: {
        student: Object,
        account: Object,
        lapidusAccount: Object,
        refresh: Function,
        country: String,
        newStudentSelected: Function,
        newStudents: Array,
    },
    data() {
        return {
            dialogOpen: false,
            dates: [],
            rates: [],
            classes: [],
            girlsClasses: [],
            editingAmount: false,
            paymentAmount: "",
            originalAmount: 0,
            processing: false,
            newStudent: {},

            gradesSetup: [],

            regID: "",

            rules: {
                required: (value, duration) => {
                    return duration == "NONE" || !!value || "Required.";
                },
            },
        };
    },
    async created() {
        await this.loadRegID();
        await this.loadRates();
        await this.loadDates();
        await this.loadClasses();
        await this.loadGradesSetup();
    },
    computed: {},
    watch: {
        newStudent(newValue, oldValue) {
            this.newStudentSelected(newValue);
        },
    },
    methods: {
        async loadRegID() {
            if (this.$route.params.reg_id) {
                this.regID = this.$route.params.reg_id;

                return;
            }

            this.regID = await this.$http.get("api/lapidusDayCamp/getRegID");
        },
        hasDayCamp(student) {
            return this.gradesSetup.find((g) => g.grade == student.class)
                .isCountryAvail;
        },
        async loadRates() {
            const rates = await this.$http.get(
                "api/lapidusDayCamp/getDayCampSetup",
            );

            this.rates = rates.filter((r) => r.udcregid == this.regID);
        },
        async loadDates() {
            const start = new Date(
                this.rates.filter(
                    (f) => f.udcclass == "LU" && f.udcregid == this.regID,
                )[0].udcstarts,
            ).toISOString();
            const end = new Date(
                this.rates.filter(
                    (f) => f.udcclass == "LU" && f.udcregid == this.regID,
                )[0].udcends,
            ).toISOString();

            const dates = await this.$http.get(
                `api/lapidusDayCamp/getHDates?startDate=${start}&endDate=${end}`,
            );

            this.dates = this.setupDates(dates);
        },
        setupDates(dates) {
            return Object.keys(groupBy(dates, "hparsha")).map((week, index) => {
                const weekDays = groupBy(dates, "hparsha")[week];

                return {
                    parshe: week,
                    weekNumber: index,
                    dates: weekDays.map((d) => Date.parse(d.pardate)),
                    sunday: this.getDayOfWeek("Sunday", weekDays),
                    monday: this.getDayOfWeek("Monday", weekDays),
                    tuesday: this.getDayOfWeek("Tuesday", weekDays),
                    wednesday: this.getDayOfWeek("Wednesday", weekDays),
                    thursday: this.getDayOfWeek("Thursday", weekDays),
                    friday: this.getDayOfWeek("Friday", weekDays),
                    saturday: this.getDayOfWeek("Saturday", weekDays),
                };
            });
        },
        getDayOfWeek(day, weekDays) {
            return weekDays.find((w) => w.day == day);
        },
        async loadClasses() {
            let classes = await this.$http.get(
                "api/classSetup/get?regID=" + this.regID,
            );

            classes = classes.filter((c) => c.classType != "Bunk");
            this.classes = classes.filter((c) => c.classType == "Lapidus");
            this.girlsClasses = classes.filter(
                (c) => c.classType == "LapidusGirls",
            );
        },
        getClassList(student) {
            return student.class.startsWith("G")
                ? this.girlsClasses
                : this.classes;
        },
        async loadGradesSetup() {
            this.gradesSetup = await this.$http.get(
                "api/lapidusDayCamp/getGradesSetup",
            );
        },
        getWeekProperty(index) {
            const weekNumber = 1 + index;

            return "week" + weekNumber;
        },
        getRate() {
            const rateCode = this.getRateCode(this.student);

            if (!rateCode) return 0;

            const rate = this.rates.find((r) => r.udcclass == rateCode);

            switch (this.student.enrollment.regType) {
                case "FULL":
                    return rate["udcamtf"];
                case "HALF 1":
                case "HALF 2":
                    return rate["udcamthalf"];
                case "CUSTOM":
                    const weekCount = Object.keys(this.student.enrollment)
                        .filter((key) => key.startsWith("week"))
                        .map((key) => this.student.enrollment[key])
                        .filter(Boolean).length;

                    return Math.min(
                        weekCount * rate["udcamt1w"],
                        rate["udcamtf"],
                    );
                default:
                    return 0;
            }
        },
        getRateCode(student) {
            if (student.class.startsWith("G")) {
                return "G";
            }

            if (!this.country) return;

            // if (this.student.class == "B-06") {
            //     switch (this.country) {
            //         case "Satmar - Lapidus":
            //             return "LU-6";
            //         default:
            //             return "LO-6";
            //     }
            // }

            if (!this.student.nonUTA) {
                switch (this.country) {
                    case "Satmar - Lapidus":
                        return "LU";
                    default:
                        if (
                            ["B-KNG", "B-NUR", "B-PRE1A"].includes(
                                this.student.class,
                            )
                        )
                            return "OU-YOUNG";

                        return "OU-OLD";
                }
            }

            switch (this.country) {
                case "Satmar - Lapidus":
                    return "LO";
                default:
                    if (
                        ["B-KNG", "B-NUR", "B-PRE1A"].includes(
                            this.student.class,
                        )
                    )
                        return "OO-YOUNG";

                    return "OO-OLD";
            }
        },
        resetPrice() {
            this.paymentAmount = this.getRate();
        },
        getPaymentAmount() {
            return this.paymentAmount || this.getRate();
        },
        edit() {
            this.editingAmount = true;
            this.originalAmount = this.paymentAmount || this.getRate();
            this.paymentAmount = this.paymentAmount || this.getRate();
        },
        rollbackEditingAmount() {
            this.paymentAmount = "";
            this.editingAmount = false;
            this.originalAmount = 0;
        },
        rollback() {
            this.student.enrollment.regType = this.original.enrollment.regType;
            this.student.enrollment.week1 = this.original.enrollment.week1;
            this.student.enrollment.week2 = this.original.enrollment.week2;
            this.student.enrollment.week3 = this.original.enrollment.week3;
            this.student.enrollment.week4 = this.original.enrollment.week4;
            this.student.enrollment.week5 = this.original.enrollment.week5;
            this.student.enrollment.week6 = this.original.enrollment.week6;
            this.student.enrollment.week7 = this.original.enrollment.week7;
            this.student.enrollment.week8 = this.original.enrollment.week8;
            this.student.enrollment.week9 = this.original.enrollment.week9;
            this.student.enrollment.lunchDoc = this.original.enrollment.lunchDoc;
            this.student.enrollment.tripMoney = this.original.enrollment.tripMoney;
            this.student.enrollment.tripAmount = this.original.enrollment.tripAmount;

            this.student.chosenClass = this.original.chosenClass;
            this.paymentAmount = 0;
            this.editingAmount = false;
            this.newStudent = "";
        },
        openDialog(original) {
            this.original = original;

            this.dialogOpen = true;
        },
        cancel() {
            this.rollback();

            this.dialogOpen = false;
        },
        validate() {
            return this.$refs.chosenClass.validate(true);
        },
        async save() {
            if (!this.validate()) return;

            this.processing = true;

            const enrollment = this.student.enrollment;

            const data = {
                familyID: this.account.accountID,
                studentID: this.student.studentID,
                id: enrollment.id,
                regID: this.regID,
                regType: enrollment.regType,
                class: this.student.class,
                classId: this.student.chosenClass
                    ? this.student.chosenClass.classID
                    : "",
                chargeCat: this.student.class.startsWith("G") ? "LPDC" : "LAPC",
                chargeCode: this.regID,
                amount: this.paymentAmount || this.getRate(),
                week1: this.hasWeek(enrollment, 1),
                week2: this.hasWeek(enrollment, 2),
                week3: this.hasWeek(enrollment, 3),
                week4: this.hasWeek(enrollment, 4),
                week5: this.hasWeek(enrollment, 5),
                week6: this.hasWeek(enrollment, 6),
                week7: this.hasWeek(enrollment, 7),
                week8: this.hasWeek(enrollment, 8),
                week9: this.hasWeek(enrollment, 9),
                lunchDoc: enrollment.lunchDoc,
                tripMoney: enrollment.tripMoney,
                tripAmount: enrollment.tripMoney ? enrollment.tripAmount : 0,
                price: this.getRate(),
            };

            try {
                await this.$http.post(
                    "api/lapidusDayCamp/updateEnrollment?user=" +
                        this.$store.state.authentication.user,
                    data,
                );
            } catch (e) {
                this.processing = false;

                return;
            }

            this.processing = false;
            this.dialogOpen = false;

            this.refresh();
        },
        hasWeek(enrollment, week) {
            switch (enrollment.regType) {
                case "FULL":
                    return true;
                case "CUSTOM":
                    const field = "week" + week;

                    return enrollment[field];
                case "HALF 1":
                    return week >= 1 && week <= 5;
                case "HALF 2":
                    return week >= 5 && week <= 9;
            }
        },
    },
};
</script>
